import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Application } from '@modules/common/types/application';
import { AdvancedSearchService } from '@modules/search/services/advanced-search.service';
import { SHEETS_STRINGS } from '@sharedlib/sheets-editor/sheets.strings';
import { VirtualFolder } from '@modules/sheets/types/virtual-folder';

@Component({
  selector: 'app-sheets-list-context-menu',
  templateUrl: './sheets-context-menu.component.html',
  styleUrls: ['./sheets-context-menu.component.less'],
  standalone: false,
})
export class SheetsContextMenuComponent {
  // Input
  @Input() filterKey: VirtualFolder;

  // Outputs
  // Named by main's DPContextMenuDirective, which subscribes to `change` on every app's context menu.
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() change = new EventEmitter<VirtualFolder>();

  /** NFR-8: the Templates view's name (Wook, 2026-10-06), from sheets.strings.ts. */
  protected readonly S = SHEETS_STRINGS;

  protected readonly searchService = inject(AdvancedSearchService);
  protected readonly isAdvancedSearchApplied = toSignal(this.searchService.isAdvancedSearchApplied(Application.sheets), {
    initialValue: false,
  });

  /**
   * Actions
   */

  selectFilter(filter: VirtualFolder) {
    this.change.emit(filter);
  }
}
